// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.light-mode {
  background-color: #fff;
  background-color: ghostwhite;
  background-color: rgb(250, 250, 250);
  --background-color: #fff;
  --background-color: ghostwhite;
  --background-color: rgb(250, 250, 250);
  color: #333;
  --color:#333;
  --button-color: #3b0062;
  --input-background: #fff;

  --button-background: rgb(221, 221, 221);

  --island-background: #fff;
  --island-background: ghostwhite;
  /* --HomePage__black-background: linear-gradient(180deg, rgba(255,255,255,1) 40%, rgba(255,255,255,0.0)); */
  --subNavBack-background: \$s-color-primary8;
  /* --island__header-background-color: \$s-color-neutral8; */
  --AssetCard2-background: #fff;
  --buyBackground: #dcf6de;
  --sellBackground: #fed6d8;
  --white-black: rgb(255,255,255);
  --black-white: #000;
  transition: background-color 0.3s ease;
}

body.dark-mode {
  background-color: #1a1919;
  --background-color: #1a1919;
  /* color: #999;
  --color: #999;
  --button-color: #999; */
  color: rgb(190, 190, 190);
  --color: rgb(190, 190, 190);
  --button-color: rgb(190, 190, 190);
  --input-background: rgb(190, 190, 190);
  --input-background: rgb(14, 14, 14);

  --button-background: rgb(44, 44, 44);

  --island-background: rgb(34, 34, 34);
  /* --HomePage__black-background: #1a1919 */
  --subNavBack-background: #1a1919
  /* --island__header-background-color: #1a1919; */
  /* --AssetCard2-background: rgb(221, 221, 221); */
  /* --buyBackground: #001101; */
  /* --sellBackground: #1b0001; */
  /* --white-black: rgb(0, 0, 0); */
  /* --black-white: #fff; */
  /* transition: background-color 0.3s ease; */
}

button.light-mode {
  background: gray;
}

/* :root {
  --main-bg-color: #1a1919;
} */`, "",{"version":3,"sources":["webpack://./pages/StellarSpaceNews/DarkMode.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;;EAExB,uCAAuC;;EAEvC,yBAAyB;EACzB,+BAA+B;EAC/B,2GAA2G;EAC3G,0CAA0C;EAC1C,0DAA0D;EAC1D,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B;;yBAEuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;;EAEnC,oCAAoC;;EAEpC,oCAAoC;EACpC,0CAA0C;EAC1C;;;;;;;;AAQF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG","sourcesContent":["body.light-mode {\n  background-color: #fff;\n  background-color: ghostwhite;\n  background-color: rgb(250, 250, 250);\n  --background-color: #fff;\n  --background-color: ghostwhite;\n  --background-color: rgb(250, 250, 250);\n  color: #333;\n  --color:#333;\n  --button-color: #3b0062;\n  --input-background: #fff;\n\n  --button-background: rgb(221, 221, 221);\n\n  --island-background: #fff;\n  --island-background: ghostwhite;\n  /* --HomePage__black-background: linear-gradient(180deg, rgba(255,255,255,1) 40%, rgba(255,255,255,0.0)); */\n  --subNavBack-background: $s-color-primary8;\n  /* --island__header-background-color: $s-color-neutral8; */\n  --AssetCard2-background: #fff;\n  --buyBackground: #dcf6de;\n  --sellBackground: #fed6d8;\n  --white-black: rgb(255,255,255);\n  --black-white: #000;\n  transition: background-color 0.3s ease;\n}\n\nbody.dark-mode {\n  background-color: #1a1919;\n  --background-color: #1a1919;\n  /* color: #999;\n  --color: #999;\n  --button-color: #999; */\n  color: rgb(190, 190, 190);\n  --color: rgb(190, 190, 190);\n  --button-color: rgb(190, 190, 190);\n  --input-background: rgb(190, 190, 190);\n  --input-background: rgb(14, 14, 14);\n\n  --button-background: rgb(44, 44, 44);\n\n  --island-background: rgb(34, 34, 34);\n  /* --HomePage__black-background: #1a1919 */\n  --subNavBack-background: #1a1919\n  /* --island__header-background-color: #1a1919; */\n  /* --AssetCard2-background: rgb(221, 221, 221); */\n  /* --buyBackground: #001101; */\n  /* --sellBackground: #1b0001; */\n  /* --white-black: rgb(0, 0, 0); */\n  /* --black-white: #fff; */\n  /* transition: background-color 0.3s ease; */\n}\n\nbutton.light-mode {\n  background: gray;\n}\n\n/* :root {\n  --main-bg-color: #1a1919;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
